import * as React from 'react';
import Switch, {SwitchVariant} from 'components/Switch';
import {ContextProvider, useContext} from './Context';
import {Toggle} from 'types';
import {
  UseTotalToggleProps,
  UseTotalToggleReturn,
  UseTotalToggleContext,
} from './types';

/**
 * The controller of a total toggle switch.
 * @param {UseTotalToggleProps} props
 * @return {UseTotalToggleReturn}
 */
export default function useTotalToggle(
    props?: UseTotalToggleProps,
) {
  const [
    isTotalToggle, setTotalToggle,
  ] = React.useState<Toggle>(true);

  const context: UseTotalToggleContext = {
    isTotalToggle,
    setTotalToggle,
  };

  /**
   * Render control.
   * @return {JSX.Element}
   */
  function renderControl(): JSX.Element {
    /**
     * The change event handler.
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      setTotalToggle(event.target.checked);
    }

    return (
      <Switch
        checked={isTotalToggle}
        label="Развернуть все дни"
        variant={SwitchVariant.Accent}
        onChange={handleChange}
      />
    );
  }
  /**
   * Wrap the content.
   * @param {JSX.Element | JSX.Element[]} content
   * @return {JSX.Element}
   */
  function wrapContent(content: JSX.Element | JSX.Element[]) {
    return (
      <ContextProvider {...context}>
        {content}
      </ContextProvider>
    );
  }

  return {
    isTotalToggle,
    renderControl,
    wrapContent,
    useContext,
  };
}

